import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import BootstrapTooltipMixin from 'app/lib/BootstrapTooltipMixin';
import Emojify from 'app/components/shared/Emojify';

/* eslint-disable react/prefer-es6-class */
// TODO: Replace BootstrapTooltipMixin and move to a class

export default createReactClass({
  displayName: "TriggerStep",

  mixins: [BootstrapTooltipMixin],

  propTypes: {
    build: PropTypes.shape({
      path: PropTypes.string.isRequired
    }).isRequired,
    job: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      state: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
      triggerProject: PropTypes.shape({
        name: PropTypes.string.isRequired
      })
    }).isRequired,
    stepClassName: PropTypes.string.isRequired
  },

  render() {
    if (this.props.job.state === "broken") {
      return (
        <div
          key={this.props.job.id}
          data-toggle="tooltip"
          title={this.props.job.tooltip}
          className={this.props.stepClassName}
        >
          <Emojify text={this.jobName()} />
        </div>
      );
    }

    return (
      <a
        key={this.props.job.id}
        href={`${this.props.build.path}#${this.props.job.id}`}
        className={this.props.stepClassName}
      >
        <Emojify text={this.jobName()} />
      </a>
    );
  },

  jobName() {
    return (
      this.props.job.name ||
      `Trigger Build on ${(
        this.props.job.triggerProject && this.props.job.triggerProject.name
          ? this.props.job.triggerProject.name
          : "unknown pipeline"
      )}`
    );
  }
});
